import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LoginInterface } from '../../../features/auth/pages/login/models/login.model';
import { LoginApiModel, LoginVerifyParamModel } from '../../models/auth.model';
import { ResponseApiModel, SecurityTokenApiResponseModel } from '../../models/general.models';
import { DeviceService } from '../storages/device.service';
import { LocalStorageService } from '../storages/local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    private route = `${environment.apiHost}/api/v1/Users`;

    constructor(
        private http: HttpClient,
        private deviceService: DeviceService,
        private localStorageService: LocalStorageService,
    ) {}

    login(loginForm: LoginInterface): Observable<SecurityTokenApiResponseModel> {
        const body = {
            email: loginForm.email,
            password: loginForm.password,
        };

        return this.http.post<ResponseApiModel<SecurityTokenApiResponseModel>>(`${this.route}/login`, body).pipe(
            map((response) => {
                return response.result;
            }),
        );
    }

    verifyLogin(otp: string, verifyParam: LoginVerifyParamModel): Observable<LoginApiModel> {
        const deviceInfo = this.deviceService.getDeviceInfo();
        const body = {
            email: verifyParam.email,
            password: verifyParam.password,
            device: deviceInfo,
            securityToken: verifyParam.securityToken,
            securityCode: otp,
        };

        return this.http.post<ResponseApiModel<LoginApiModel>>(`${this.route}/verify-login`, body).pipe(
            map((response) => {
                const loginProfile = response.result;
                this.localStorageService.setLoginUser(loginProfile);
                return loginProfile;
            }),
        );
    }

    logout(): Observable<boolean> {
        return this.http.post<ResponseApiModel<boolean>>(`${this.route}/logout`, {}).pipe(
            finalize(() => {
                this.localStorageService.clearLoginUser();
                this.deviceService.clear();
            }),
            map((response) => response.result),
        );
    }

    refreshToken(): Observable<LoginApiModel> {
        const headers = {
            Authorization: `Bearer ${this.localStorageService.getLoginUser()?.refreshToken}`,
        };

        const params = {
            noToken: '1',
            refresh: '1',
        };

        return this.http
            .post<ResponseApiModel<LoginApiModel>>(`${this.route}/refreshToken`, {}, { headers, params })
            .pipe(map((resp) => resp.result));
    }
}
